import { React, useEffect, useState } from 'react';
import { apiUrl } from '../../config'
import { fetchData } from '../../utils/api';
import { intervalUpdatingData } from '../../utils/dynamic';
import DownloadReport from './DownloadReport';
import DownloadReportBookings from './DownloadReportBookings';
import { useAdminLanguage } from '../../AdminLanguageContext';
import { translateAdmin } from '../../utils/adminTranslations';

function Dashboard({ type }) {
  const { language } = useAdminLanguage();
  const translate = (text) => translateAdmin(text, language);
  const [dashboardInfo, setDashboardInfo] = useState([])

  const fetch = async () => {
    const token = localStorage.getItem('accessToken');
    const response = await fetchData(`${apiUrl}/api/sys/get-dashboard-info?type=${type}`, "GET", token)
    if (response.request.status)
      console.error("Ошибка загрузки данных:", response.request.message);
    else {
      setDashboardInfo(response.request.data);
    }
  };
  useEffect(() => {
    fetch();
    const interval = setInterval(() => {
      setTimeout(() => {
        fetch()
      }, 3000)
    }, intervalUpdatingData)
    return () => clearInterval(interval);

  }, []);

  return (
    <section className="system-dashboard">
      <div className="card">
        <h3>{translate('Общий доход')}</h3>
        <p>{dashboardInfo.total_sum} TMT</p>
        <h3>{translate('Количество')}</h3>
        <p>{dashboardInfo.active_count_bookings}</p>
      </div>
      <div className="card">
        <h3>{translate('Доход за бронирования')}</h3>
        <p>{dashboardInfo.total_sumBooking} TMT</p>
        <h3>{translate('Количество')}</h3>
        <p>{dashboardInfo.active_forbookings_count}</p>
      </div>
      <div className="card">
        <h3>{translate('Доход за проживания')}</h3>
        <p>{dashboardInfo.total_sum_settle} TMT</p>
        <h3>{translate('Количество')}</h3>
        <p>{dashboardInfo.active_forsettle_count}</p>
      </div>
      <div className="card">
        <h3>{translate('Отчет')}</h3>
        <DownloadReport />
      </div>
      <div className="card">
        <h3>{translate('Вывести бронирования')}</h3>
        <DownloadReportBookings />
      </div>
    </section>
  );
}

export default Dashboard;
